import React, { Component } from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import MediaQuery from 'react-responsive'
import BackgroundVideo from 'react-background-video-player'
import AnimatedBorder from './animated-border'
import { mobile, desktop, tablet } from '../utils/media'

const Wrapper = styled.div`
  position: relative;
  padding-bottom: 82%;
  height: 100%;
  max-height: 780px;
  overflow: hidden;

  ${mobile`
    padding-bottom: 41%;
  `}

  ${tablet`
    padding-bottom: 45%;
  `}
`

const Text = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Title = styled.h1`
  margin: 0 0 5px 0;
  font-family: 'butlerregular';
  font-weight: 400;
  text-align: center;
  font-size: calc(45px + (80 - 45) * ((100vw - 480px) / (1920 - 480)));
  line-height: 1;
`

const Description = styled.p`
  margin: 0 0 10px 0;
  font-size: calc(15px + (22 - 15) * ((100vw - 480px) / (1920 - 480)));
  line-height: 1;
  text-align: center;
`

const Roles = styled.p`
  display: flex;
  margin: 0 0 10px 0;
  font-size: calc(15px + (22 - 15) * ((100vw - 480px) / (1920 - 480)));
  text-align: center;
  line-height: 1;

  :last-child {
    margin: 0;
  }

  span {
    position: relative;
    margin: 5px 30px 0 0;

    ${tablet`
      margin: 30px 60px 0 0;
    `};

    :last-child {
      margin-right: 0;
    }

    :not(:last-child)::after {
      content: "";
      position: absolute;
      top: 50%;
      right: -25px;
      display: inline-block;
      max-width: 20px;
      width: 100%;
      height: 1px;
      background: #fff;

      ${tablet`
        right: -55px;
        max-width: 50px;
      `};
    }
  }
`

export default class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doAnimation: false,
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        window.addEventListener('resize', this.handleResize)
        window.addEventListener('orientationchange', this.handleResize)
      }, 100)
    }

    setTimeout(() => {
      this.setState({ doAnimation: true })
    }, 100)
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
      window.removeEventListener('orientationchange', this.handleResize)
    }
  }


  handleResize = () => {
    this.setState({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    })
  }

  render() {
    return (
      <Link to="/en/about/">
        <Wrapper>
          <MediaQuery minWidth={1024}>
            <AnimatedBorder doAnimation={this.state.doAnimation} />
          </MediaQuery>
          <BackgroundVideo
            src={require("../../static/about.mp4")}
            containerWidth={this.state.windowWidth ? this.state.windowWidth : 0}
            containerHeight={this.state.windowHeight ? this.state.windowHeight : 0}
          />
          <Text>
            <Title>Dmitry Golubev</Title>
            <Description>The man with the microphon</Description>
            <Roles>
              <span>Presenter</span>
              <span>Creator</span>
              <span>Director</span>
              <span>Human</span>
            </Roles>
          </Text>
        </Wrapper>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/about.js